import { cloneDeep, set, update } from "lodash-es"
import { useReducer, useState } from "react"
import useErrors from "./useErrors"

// import  from "yup";
function reducer(state, action) {
  switch (action.type) {
    case "add":
      const stateAdd = cloneDeep(state)
      update(stateAdd, action.path, arr => arr.concat(action.payload))
      return stateAdd
    case "remove":
      const stateRemove = cloneDeep(state)
      update(stateRemove, action.path, arr =>
        arr.filter((item, idx) => idx !== action.payload)
      )
      return stateRemove
    case "change":
      const stateChange = cloneDeep(state)
      set(stateChange, action.path, action.payload)
      return stateChange
    case "mutate":
      return action.payload
    case "clear":
      return {}
    default:
      return state
  }
}
const useForm = ({ initialState, schema }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const [focused, changeFocused] = useState({})
  const [errors] = useErrors({ schema, state })
  const change = (path, payload) => dispatch({ type: "change", path, payload })
  const add = (path, payload) => dispatch({ type: "add", path, payload })
  const remove = (path, payload) => dispatch({ type: "remove", path, payload })
  const mutate = payload => dispatch({ type: "mutate", payload })
  const clear = () => dispatch({ type: "clear" })
  const submit = () => {}
  const focus = path => {
    if (!focused[path]) {
      changeFocused(prevFocused => ({
        ...prevFocused,
        [path]: true,
      }))
    }
  }
  return {
    state,
    submit,
    focused,
    change,
    errors,
    add,
    focus,
    remove,
    mutate,
    clear,
  }
}

export default useForm
